var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{attrs:{"type":"tel","value":_vm.string,"placeholder":_vm.placeholder},on:{"input":_vm.changeHandle,"blur":_vm.blurHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }